<template lang="pug">
div
  div.row.d-flex.justify-content-center.text-center.mb-3
    h4 Membership Cards

  div.row.no-gutters.justify-content-center
    div.col-md-7.col-lg-5
      div.row.justify-content-center.text-center.mb-5(v-if="oldId")
        p OH NO! Seems like you tried to follow an old link.
        p We've updated the system to be more privacy minded so please order a new membership link. Sorry about that!

      div.row.justify-content-center.text-center.mb-5(v-else)
        p You can access your very own digital membership card by clicking the link in your email.

      div.row.justify-content-center.text-center(v-if="showResult")
        p(v-if="emailError") Oh snap! There was an error sending an email to <strong>{{email}}</strong>. Please contact us at members@igda.fi and we'll sort this out together.<br/><small>Details: {{emailError}}</small>
        p(v-else) Success! Email sent to <strong>{{email}}</strong> and should arrive shortly.
      div.row.justify-content-center.text-center(v-if="wrongEmail")
        p(v-if="emailError") We couldn't find anyone with the email <strong>{{wrongEmailAddress}}</strong>. Maybe you registered with something else?

      div.row.justify-content-center.text-center(v-if="showSpinner")
        p Sending email...

      div(v-if="!hideForm")
        div.row.justify-content-center.text-center.mb-3
          small Lost the email? Don't panic!

        form
          div.row.justify-content-center.mb-1
            input(type="email" name="email" v-model="email" required)
          div.row.justify-content-center.text-center.mb-3
            small.text-muted(v-if="!isFormValid") Please fill in a valid email.

          div.row.justify-content-center
            button(:disabled="!isFormValid" @click="sendEmail(email)") Request Link
</template>

<script>
export default {
  name: 'home',
  data: function () {
    return {
      hideForm: false,
      showSpinner: false,
      showResult: false,
      wrongEmail: false,
      emailError: null,
      wrongEmailAddress: '',
      email: '',
      oldId: null
    }
  },
  computed: {
    isFormValid: function () {
      let result = true
      if (this.email === '') result = false
      return result
    }
  },
  methods: {
    sendEmail: function (email) {
      this.showSpinner = true
      this.hideForm = true
      this.emailError = false
      this.wrongEmail = false
      this.showResult = false

      this.axios.post('/api/cards/get-link', { email: this.email })
        .then(res => {
          this.showResult = true
          this.showSpinner = false
        })
        .catch(err => {
          this.emailError = err
          this.showSpinner = false
          this.hideForm = false
          if (err.response.status === 400) {
            this.wrongEmail = true
            this.wrongEmailAddress = this.email
            this.email = ''
          } else { this.showResult = true }
        })
    }
  },
  mounted: function () {
    if (this.$route.params.hasOwnProperty('oldId')) this.oldId = this.$route.params.oldId
  }
}
</script>
